import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type CollectionUniquenessVariables = Types.Exact<{
  slug: Types.Scalars['citext'];
}>;


export type CollectionUniqueness = { collections: Array<Pick<Types.Collection, 'id' | 'slug'>> };



export const CollectionUniquenessDocument = /*#__PURE__*/ `
    query CollectionUniqueness($slug: citext!) {
  collections: collection(where: {slug: {_eq: $slug}}) {
    id
    slug
  }
}
    `;

export const useCollectionUniqueness = <
      TData = CollectionUniqueness,
      TError = ClientError
    >(
      variables: CollectionUniquenessVariables,
      options?: Omit<UseQueryOptions<CollectionUniqueness, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CollectionUniqueness, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CollectionUniqueness, TError, TData>(
      {
    queryKey: ['CollectionUniqueness', variables],
    queryFn: hasuraFetcher<CollectionUniqueness, CollectionUniquenessVariables>(CollectionUniquenessDocument, variables),
    ...options
  }
    )};

useCollectionUniqueness.getKey = (variables: CollectionUniquenessVariables) => ['CollectionUniqueness', variables];

export const useInfiniteCollectionUniqueness = <
      TData = InfiniteData<CollectionUniqueness>,
      TError = ClientError
    >(
      variables: CollectionUniquenessVariables,
      options: Omit<UseInfiniteQueryOptions<CollectionUniqueness, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CollectionUniqueness, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CollectionUniqueness, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CollectionUniqueness.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<CollectionUniqueness, CollectionUniquenessVariables>(CollectionUniquenessDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCollectionUniqueness.getKey = (variables: CollectionUniquenessVariables) => ['CollectionUniqueness.infinite', variables];


useCollectionUniqueness.fetcher = (variables: CollectionUniquenessVariables, options?: RequestInit['headers']) => hasuraFetcher<CollectionUniqueness, CollectionUniquenessVariables>(CollectionUniquenessDocument, variables, options);
